/** Initialen aus einem Namen, „Muster, Max“ wie „Max Muster“: erstes und letztes Wort. */
export function initialen(name: string): string {
  const woerter = name.split(/[\s,]+/).filter(Boolean);
  const erstes = woerter[0]?.[0] ?? '';
  const letztes = woerter.length > 1 ? (woerter[woerter.length - 1]?.[0] ?? '') : '';
  return (erstes + letztes).toUpperCase();
}
